
import { MathX } from "../../../math/MathX";
import { AudioGraph } from "../AudioGraph";
import { AudioGraphNodeType } from "../AudioGraphNodeType";
import { AudioGraphNode } from "./AudioGraphNode";

export class DynamicsCompressor extends AudioGraphNode<DynamicsCompressorNode>
{
  constructor( graph:AudioGraph, id:number )
  {
    super( graph, id, AudioGraphNodeType.DynamicsCompressor );
  }

  protected _assignAudioNode()
  {
    this._node = this._context.createDynamicsCompressor();
  }

  setLimiter( amount:number, release:number = 0.1 )
  {
    amount = MathX.clamp01( amount ) * 99 + 1; 

    this._node.threshold.value = -6;
    this._node.knee.value = 6;
    this._node.ratio.value = amount;
    this._node.attack.value = 0;
    this._node.release.value = release;
  }
}